import React, { useEffect, useState } from "react";
import "./societyDetails.scss";
import { connect } from "react-redux";
import { addSociety } from "../../../redux/slice/addSocietySlice";
import PageLoader from "../../common/pageLoader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Notify from "../../common/notify/notify";
import * as Yup from "yup";
import { Cookies } from "react-cookie";
import SocietyDetailsComponent from "./societyDetails";
import { societyDetails } from "../../../redux/slice/societyDetailsSlice";
import { societyUpdate } from "../../../redux/slice/societyUpdateSlice";
import { City, State } from "country-state-city";

const SocietyDetails = (props) => {
  const {
    calladdSocietyData,
    addSocietyData,
    callsocietyDetailsData,
    societyDetailsData,
    callsocietyUpdateData,
    societyUpdateData,
  } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const cookies = new Cookies();
  const loading =
    addSocietyData.isLoading ||
    societyDetailsData.isLoading ||
    societyUpdateData.isLoading;
  const society_detail_data =
    societyDetailsData?.societyDetailsData?.data?.data[0]?._id;

  const wingLength =
    societyDetailsData?.societyDetailsData?.data?.data[0]?.wings.length;
  const wingFlor_length =
    societyDetailsData?.societyDetailsData?.data?.data[0]?.wings;

  const [cities, setCities] = useState([]);
  const states = State.getStatesOfCountry("IN");

  const updateLoader = societyUpdateData.isLoading;
  const location = useLocation();
  const isEditRoute = location.pathname.includes("/edit-details");
  const [validation, setValidation] = useState({});
  const [DefaultError, setDefaultError] = useState({});
  const [wingLabels, setWingLabels] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    address: "",
    street: "",
    city: "",
    state: "",
    pin_code: "",
    type: "",
    registration_number: "",
    wings: [],
  });
  const [followPattern, setFollowPattern] = useState(false);
  const validationSchema = Yup.object({
    name: Yup.string().required("Please enter the society name to proceed."),
    address: Yup.string().required("Please enter your address to proceed."),
    city: Yup.string().required("Please select your city to proceed."),
    pin_code: Yup.string().required("Please enter your pincode to proceed."),
    type: Yup.string().required("Please select a society type to proceed."),
    state: Yup.string().required("Please select your state to proceed."),
    wings: Yup.array().of(
      Yup.object().shape({
        numberOfFloors: Yup.string().required("Please enter the number of floors per wing to proceed."),
        flatsPerFloor: Yup.string().required("Please enter the number of flats per floor to proceed."),
        startFlatNumber: Yup.string().required("Please enter the start flat number to proceed."),
      })
    ),
  });

  useEffect(() => {
    const main_id = addSocietyData?.addSocietyData?.data?.data?._id || null;
    if (main_id) {
      cookies.set("society_id", main_id);
    }
  }, [addSocietyData]);

  const handleSelectChange = (value) => {
    const labels = Array.from({ length: parseInt(value, 10) }, (_, i) =>
      String.fromCharCode(65 + i)
    );

    setWingLabels(labels);

    const newWings = labels.map((label) => {
      const existingWing = formValues.wings.find((wing) => wing.name === label);

      return existingWing
        ? existingWing
        : {
            name: label,
            _id: null,
            flatsPerFloor: "",
            numberOfFloors: "",
            startFlatNumber: "",
          };
    });

    setFormValues((prevValues) => ({
      ...prevValues,
      wings: newWings,
    }));

    setDefaultError({ wing: "" });
  };

  const handleFieldChange = (name, field, value) => {
    setFormValues((prevValues) => {
      const updatedWings = prevValues.wings.map((wing) =>
        wing.name === name ? { ...wing, [field]: value } : wing
      );

      if (followPattern && name === "A") {
        const aWingValues = updatedWings.find((wing) => wing.name === "A");

        return {
          ...prevValues,
          wings: updatedWings.map((wing) => ({
            ...wing,
            flatsPerFloor: aWingValues.flatsPerFloor || 0,
            numberOfFloors: aWingValues.numberOfFloors || 0,
            startFlatNumber: aWingValues.startFlatNumber,
          })),
        };
      }

      return { ...prevValues, wings: updatedWings };
    });

    setValidation((prevState) => {
      const index = formValues.wings.findIndex((wing) => wing.name === name);
      const fieldKey = `wings[${index}].${field}`;
      const newValidation = { ...prevState };

      if (value) {
        delete newValidation[fieldKey];
      }

      return newValidation;
    });
  };

  const handleCheckboxChange = (isChecked) => {
    setFollowPattern(isChecked);

    setFormValues((prevValues) => {
      const firstWing =
        prevValues.wings.find((wing) => wing.name === "A") || {};

      return {
        ...prevValues,
        wings: prevValues.wings.map((wing) => {
          const isFirstWing = wing.name === "A";
          const isSelectedWing =
            isEditRoute &&
            wingFlor_length.some(
              (existingWing) => existingWing.name === wing.name
            );
          const isNewWing =
            isEditRoute &&
            !wingFlor_length.some(
              (existingWing) => existingWing.name === wing.name
            );

          if (isFirstWing) {
            return { ...wing };
          }

          if (isEditRoute) {
            if (isSelectedWing) {
              return {
                ...wing,
                flatsPerFloor: isChecked
                  ? firstWing.flatsPerFloor
                  : wing.flatsPerFloor,
                numberOfFloors: isChecked
                  ? firstWing.numberOfFloors
                  : wing.numberOfFloors,
                startFlatNumber: isChecked
                  ? firstWing.startFlatNumber
                  : wing.startFlatNumber,
              };
            }

            if (isNewWing) {
              return {
                ...wing,
                flatsPerFloor: isChecked ? firstWing.flatsPerFloor : "",
                numberOfFloors: isChecked ? firstWing.numberOfFloors : "",
                startFlatNumber: isChecked ? firstWing.startFlatNumber : "",
              };
            }
          }
          return {
            ...wing,
            flatsPerFloor: isChecked ? firstWing.flatsPerFloor : "",
            numberOfFloors: isChecked ? firstWing.numberOfFloors : "",
            startFlatNumber: isChecked ? firstWing.startFlatNumber : "",
          };
        }),
      };
    });

    if (isChecked) {
      setValidation((prevValidation) => {
        const newValidation = { ...prevValidation };

        formValues.wings.forEach((wing, index) => {
          delete newValidation[`wings[${index}].flatsPerFloor`];
          delete newValidation[`wings[${index}].numberOfFloors`];
          delete newValidation[`wings[${index}].startFlatNumber`];
        });

        return newValidation;
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: ["phone_number", "code", "pin_code"].includes(name)
        ? value === "" || /^[0-9]*$/.test(value) 
          ? value
          : prevState[name] 
        : value,
    }));
    setValidation((prevState) => ({ ...prevState, [name]: "" }));
  };

  const handleTypeChange = (value) => {
    setFormValues((prevValues) => ({ ...prevValues, type: value }));
    setValidation((prevValues) => ({ ...prevValues, type: "" }));
  };

  const handleStateChange = (value) => { 
    const selectedStateObj = states.find(s => s.isoCode === value);
    setFormValues(prevValues => ({
        ...prevValues,
        state: selectedStateObj ? selectedStateObj.name : '',
        city: '' 
    }));

    if (value) {
        setCities(City.getCitiesOfState('IN', value));
    } else {
        setCities([]);
    }
    setValidation(prev => ({...prev, state: '', city: ''}));
  };

  const handleCityChange = (value) => { 
      setFormValues(prevValues => ({
          ...prevValues,
          city: value
      }));
      setValidation(prev => ({...prev, city: ''}));
  };

  const handleAddSociety = async () => {
    let error = {};

    if (formValues.wings.length === 0) error.wings = "Please select the number of wings to proceed.";
    setDefaultError(error);

    try {
      await validationSchema.validate(formValues, { abortEarly: false });
      if (Object.keys(error).length === 0) {
        const societyData = {
          name: formValues.name,
          address: {
            street: formValues.address,
            city: formValues.city,
            state: formValues.state,
            pin_code: Number(formValues.pin_code),
          },
          type: formValues.type,
          registration_number: formValues.registration_number,
          wings: formValues.wings,
        };

        const result = await calladdSocietyData(societyData);
        if (result.type === "addSociety/fulfilled") {
          setFormValues({
            name: "",
            address: "",
            street: "",
            city: "",
            state: "",
            pin_code: "",
            type: "",
            registration_number: "",
            wings: [],
          });
          navigate("/president-details");
          Notify("success", "The society has been added successfully.", "");
        }
        if (result.type === "addSociety/rejected") {
          Notify("error", "Oops! Something went wrong. Please try again later.", "");
        }
      }
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((e) => {
        newErrors[e.path] = e.message;
      });
      setValidation(newErrors);
    }
  };

  useEffect(() => {
    const handleSocietyDetails = async () => {
        const result = await callsocietyDetailsData(id);
        if (result.type === "societyDetails/fulfilled") {
            const searSocietyData = result.payload.data?.data[0];

            if (searSocietyData) {
                const stateObj = states.find(s => s.name === searSocietyData.address.state);
                if (stateObj) {
                    setCities(City.getCitiesOfState('IN', stateObj.isoCode));
                }

                const wingsData = searSocietyData.wings?.map((wing) => ({
                    _id: wing._id,
                    name: wing.name,
                    flatsPerFloor: wing.flat_per_floor,
                    numberOfFloors: wing.total_floors,
                    startFlatNumber: Array.isArray(wing.flat_numbers) && wing.flat_numbers.length > 0 ? wing.flat_numbers[0] : "",
                })) || [];

                setWingLabels(wingsData.map((wing) => wing.name));
                setFormValues({
                    name: searSocietyData.name,
                    address: searSocietyData.address.street,
                    city: searSocietyData.address.city,
                    state: searSocietyData.address.state,
                    pin_code: searSocietyData.address.pin_code,
                    type: searSocietyData.type,
                    registration_number: searSocietyData.registration_number,
                    wings: wingsData,
                });
            }
        }
    };

    if (id) {
        handleSocietyDetails();
    }
  }, [id, callsocietyDetailsData]); 


  const handelUpdateDetails = async () => {
    try {
      setValidation({});
      await validationSchema.validate(formValues, { abortEarly: false });
      const editedData = {
        societyId: society_detail_data,
        name: formValues.name,
        address: {
          street: formValues.address,
          city: formValues.city,
          state: formValues.state,
          pin_code: Number(formValues.pin_code),
        },
        type: formValues.type,
        registration_number: formValues.registration_number,
        wings: formValues.wings,
      };

      const result = await callsocietyUpdateData(editedData);

      if (result.type === "societyUpdate/fulfilled") {
        Notify("success", "The changes have been updated successfully.", "");
        navigate("/society-list");
      }
      if (result.type === "societyUpdate/rejected") {
        Notify("error", "Oops! Something went wrong. Please try again later.", "");
      }
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((e) => {
        newErrors[e.path] = e.message;
      });

      setValidation(newErrors);
    }
  };

  return (
    <>
      {loading && <PageLoader />}
      <SocietyDetailsComponent
        id={id}
        formValues={formValues}
        wingLabels={wingLabels}
        followPattern={followPattern}
        validation={validation}
        DefaultError={DefaultError}
        onInputChange={handleInputChange}
        onTypeChange={handleTypeChange}
        onSelectChange={handleSelectChange}
        onFieldChange={handleFieldChange}
        onCheckboxChange={handleCheckboxChange}
        onAddSociety={handleAddSociety}
        loading={loading}
        handelUpdateDetails={handelUpdateDetails}
        updateLoader={updateLoader}
        wingLength={wingLength}
        wingFlor_length={wingFlor_length}
        isEditRoute={isEditRoute}
        states={states}
        cities={cities}
        onStateChange={handleStateChange}
        onCityChange={handleCityChange}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  addSocietyData: state.addSocietyData,
  societyDetailsData: state.societyDetailsData,
  societyUpdateData: state.societyUpdateData,
});

const mapDispatchToProps = (dispatch) => ({
  calladdSocietyData: (data) => dispatch(addSociety(data)),
  callsocietyDetailsData: (data) => dispatch(societyDetails(data)),
  callsocietyUpdateData: (data) => dispatch(societyUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocietyDetails);
